<template>
  <div class="big">
    <DocMsg
      :isFlag="doc_msg"
      :doctorId="doctorId"
    ></DocMsg>
    <div class="container">
      <div>
        <div class="box">
          <div class="searchbox">
            <div>
              <span>医生姓名</span>
              <el-input
                v-model="doctor_name"
                style="width:160px;margin:0 20px 0 10px"
                @input="search"
                clearable
              ></el-input>
              <span>手机号</span>
              <el-input
                v-model="phone"
                style="width:160px;margin:0 20px 0 10px"
                @input="search"
                clearable
              ></el-input>
              <el-button
                type="info"
                style="background-color:#eceff2;;color:#747981;"
                @click="search"
              >查询</el-button>
              <span style="margin:0 10px 0 15px">是否认证</span>
              <el-radio-group
                v-model="is_auth"
                @change="search"
              >
                <el-radio :label="0">全部</el-radio>
                <el-radio :label="1">是</el-radio>
                <el-radio :label="2">否</el-radio>
              </el-radio-group>
            </div>
            <el-button
              type="primary"
              :disabled="module_id_array[0]?!module_id_array.includes('277'):false"
              @click="dialogadd=true;search_phone='';noinfo=false;detail={}"
            >添加医生</el-button>
          </div>

          <div style="border: solid 1px #c9cbd6;">
            <el-table
              ref="multipleTable"
              :data="tableData"
              tooltip-effect="dark"
              style="width: 100%;min-width:1000px;"
              :header-cell-style="{background:'#F5F5F5'}"
            >
              <el-table-column label="医生头像">
                <template slot-scope="scope">
                  <img
                    :src="scope.row.head_img"
                    alt
                    style="width:80px;height:80px"
                  />
                </template>
              </el-table-column>
              <el-table-column label="医生姓名">
                <template slot-scope="scope">
                  <span
                    @click="showDocMsg(scope.row.doctor_id)"
                    style="cursor:pointer;margin-right:12px"
                  >{{scope.row.doctor_name}}</span>
                  <span v-if="scope.row.sex==1">男</span>
                  <span v-if="scope.row.sex==2">女</span>
                  <span v-if="scope.row.sex==0">未知</span>
                </template>
              </el-table-column>
              <el-table-column
                label="手机号"
                prop="phone"
              ></el-table-column>
              <el-table-column
                label="医院名称"
                prop="hospital"
              ></el-table-column>
              <el-table-column
                label="科室"
                prop="department_name"
              ></el-table-column>
              <el-table-column
                label="职称"
                prop="title"
              ></el-table-column>
              <el-table-column label="是否认证">
                <template slot-scope="scope">
                  <span v-if="scope.row.is_auth==1">是</span>
                  <span v-else>否</span>
                </template>
              </el-table-column>
              <el-table-column label="请求协诊权限">
                <template slot-scope="scope">
                  <el-switch
                    v-model="scope.row.request_assist"
                    active-color="#669961"
                    @change="(value)=>{return changeRepuest(value,scope.row.doctor_id)}"
                  ></el-switch>
                </template>
              </el-table-column>
              <el-table-column label="协诊权限">
                <template slot-scope="scope">
                  <el-switch
                    v-model="scope.row.assist"
                    active-color="#669961"
                    @change="(value)=>{return changeAssist(value,scope.row.doctor_id)}"
                  ></el-switch>
                </template>
              </el-table-column>
              <el-table-column
                label="排序"
                width="200"
              >
                <template slot-scope="scope">
                  <el-button
                    type="text"
                    @click="editSort(scope.row.id,1)"
                    :disabled="module_id_array[0]?!module_id_array.includes('245'):false"
                  >置顶</el-button>
                  <el-button
                    type="text"
                    @click="editSort(scope.row.id,2)"
                    :disabled="module_id_array[0]?!module_id_array.includes('245'):false"
                  >上移</el-button>
                  <el-button
                    type="text"
                    @click="editSort(scope.row.id,3)"
                    :disabled="module_id_array[0]?!module_id_array.includes('245'):false"
                  >下移</el-button>
                  <el-button
                    type="text"
                    @click="editSort(scope.row.id,4)"
                    :disabled="module_id_array[0]?!module_id_array.includes('245'):false"
                  >置底</el-button>
                </template>
              </el-table-column>
              <el-table-column label="操作">
                <template slot-scope="scope">
                  <el-button
                    style="color:#D9001B"
                    type="text"
                    @click="del(scope.row.doctor_id)"
                    :disabled="module_id_array[0]?!module_id_array.includes('277'):false"
                  >删除</el-button>
                </template>
              </el-table-column>
            </el-table>
          </div>
          <div>
            <el-pagination
              @size-change="handleSizeChange"
              @current-change="handleCurrentChange"
              :current-page="currentPage"
              :page-sizes="[10, 20, 50, 100]"
              :page-size="10"
              layout="total, sizes, prev, pager, next, jumper"
              :total="totalNum"
              style="margin:20px 0"
            ></el-pagination>
          </div>
        </div>
      </div>
    </div>
    <!-- 添加医生弹窗 -->
    <el-dialog
      title="添加医生"
      :visible.sync="dialogadd"
      width="460px"
      style="text-align:left"
      :close-on-click-modal="false"
    >
      <div class="diabox">
        <div
          class="flex align-center"
          style="margin-bottom:20px"
        >
          <span>手机号：</span>
          <el-input
            v-model="search_phone"
            clearable
            style="width:320px"
            placeholder="请输入手机号"
            @input="searchDoctor"
          ></el-input>
        </div>
        <div v-if="noinfo">
          <span>医生姓名：</span>
          <span>该账号未注册，请核实</span>
        </div>
        <div v-if="detail.doctor_name&&!noinfo">
          <div class="diaitem">
            <span class="title">医生姓名：</span>
            <div class="doctor">
              <span>{{detail.doctor_name}}</span>
              <span v-if="detail.sex==1">男</span>
              <span v-if="detail.sex==2">女</span>
              <span v-if="detail.sex==0">未知</span>
              <span>{{detail.age}}</span>
            </div>
          </div>
          <div class="diaitem">
            <span>
              <span class="title">职称：</span>
              <span>{{detail.title}}</span>
            </span>
            <span>
              <span class="title">科室：</span>
              <span>{{detail.department_name}}</span>
            </span>
          </div>
          <div class="diaitem">
            <span>
              <span class="title">医院：</span>
              <span>{{detail.hospital}}</span>
            </span>
          </div>
        </div>
      </div>
      <div
        slot="footer"
        class="dialog-footer"
      >
        <el-button @click="dialogadd = false">取 消</el-button>
        <el-button
          type="primary"
          @click="addDoctor"
        >确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import clinic from '../../../api/clinic';
import DocMsg from '../../../components/common/DocMsg.vue';
import _ from 'lodash';
export default {
  data() {
    return {
      currentPage: 1,
      pagesize: 10,
      totalNum: 0,
      tableData: [],
      doctor_name: '',
      phone: '',
      is_auth: 0,
      detail: {},
      noinfo: false,
      dialogadd: false,
      search_phone: '',
      doc_msg: false,
      doctorId: ''
    };
  },
  computed: {
    module_id_array() {
      return this.$store.state.userInfo.userInfo.module_id_array;
    }
  },
  components: {
    DocMsg
  },
  methods: {
    //医生信息概要
    showDocMsg(doctor_id) {
      this.doctorId = doctor_id;
      this.doc_msg = !this.doc_msg;
    },
    //获取列表
    getList() {
      let data = {
        page: this.currentPage,
        pageNumber: this.pagesize,
        department_id: this.$route.query.department_id,
        doctor_name: this.doctor_name,
        phone: this.phone,
        is_auth: this.is_auth
      };
      clinic
        .getDoctorMaintenanceList(data)
        .then((res) => {
          if (res.code == 0) {
            this.tableData = res.data.list.map((item) => {
              item.request_assist = item.request_assist == 1 ? true : false;
              item.assist = item.assist == 1 ? true : false;

              return item;
            });
            this.totalNum = res.data.total;
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    search(value, status) {
      if (status) {
        if (!value) {
          this.date = [];
        }
      }
      this.currentPage = 1;
      this.getList();
    },
    //每页数据的条数
    handleSizeChange(size) {
      this.pagesize = size;
      this.getList();
    },
    //当前第几页
    handleCurrentChange(currentPage) {
      this.currentPage = currentPage;
      this.getList();
    },
    //设置请求协诊权限
    changeRepuest(value, doctor_id) {
      let department_id = this.$route.query.department_id;

      if (value) {
        this.$confirm('是否开启【请求协诊】权限？', '提示', {
          closeOnClickModal: false,
          distinguishCancelAndClose: true,
          confirmButtonText: '确定',
          cancelButtonText: '取消'
        })
          .then(() => {
            let data = {
              department_id,
              doctor_id,
              jurisdiction: 1
            };
            clinic.setRequestAssist(data).then((res) => {
              if (res.code == 0) {
                this.$message.success('已开启请求协诊权限');
                this.getList();
              }
            });
          })
          .catch(() => {
            this.getList();
          });
      } else {
        this.$confirm('是否关闭【协诊】权限？', '提示', {
          closeOnClickModal: false,
          distinguishCancelAndClose: true,
          confirmButtonText: '确定',
          cancelButtonText: '取消'
        })
          .then(() => {
            let data = {
              department_id,
              doctor_id,
              jurisdiction: 0
            };
            clinic.setRequestAssist(data).then((res) => {
              if (res.code == 0) {
                this.$message.success('已关闭请求协诊权限');
                this.getList();
              }
            });
          })
          .catch(() => {
            this.getList();
          });
      }
    },
    //设置协诊权限
    changeAssist(value, doctor_id) {
      let department_id = this.$route.query.department_id;
      if (value) {
        this.$confirm('是否开启【请求协诊】权限？', '提示', {
          closeOnClickModal: false,
          distinguishCancelAndClose: true,
          confirmButtonText: '确定',
          cancelButtonText: '取消'
        })
          .then(() => {
            let data = {
              department_id,
              doctor_id,
              jurisdiction: 1
            };
            clinic.setAssist(data).then((res) => {
              if (res.code == 0) {
                this.$message.success('已开启协诊权限');
                this.getList();
              }
            });
          })
          .catch();
      } else {
        this.$confirm('是否关闭【协诊】权限？', '提示', {
          closeOnClickModal: false,
          distinguishCancelAndClose: true,
          confirmButtonText: '确定',
          cancelButtonText: '取消'
        })
          .then(() => {
            let data = {
              department_id,
              doctor_id,
              jurisdiction: 0
            };
            clinic.setAssist(data).then((res) => {
              if (res.code == 0) {
                this.$message.success('已关闭协诊权限');
                this.getList();
              }
            });
          })
          .catch();
      }
    },
    //排序
    editSort(id, sort) {
      let department_id = this.$route.query.department_id;
      let data = {
        id,
        sort,
        department_id
      };
      clinic.editDoctorSort(data).then((res) => {
        if (res.code == 0) {
          this.getList();
        }
      });
    },
    //删除
    del(doctor_id) {
      let department_id = this.$route.query.department_id;

      this.$confirm('您确定要删除该医生吗？特色科室将不再展示此人', '提示', {
        closeOnClickModal: false,
        distinguishCancelAndClose: true,
        confirmButtonText: '确定',
        cancelButtonText: '取消'
      })
        .then(() => {
          clinic.delDoctor({ department_id, doctor_id }).then((res) => {
            if (res.code == 0) {
              this.$message.success('已删除');
              this.getList();
            }
          });
        })
        .catch();
    },
    //电话号码查询医生
    searchDoctor(value) {
      let reg = /^(1[123456789])\d{9}$/;
      if (reg.test(value)) {
        let phone = value;
        clinic.searchDoctorInfo({ phone }).then((res) => {
          if (res.code == 0) {
            let info = res.data.info;
            if (info.doctor_name) {
              this.noinfo = false;
              this.detail = info;
            } else {
              this.noinfo = true;
            }
          }
        });
      }
    },
    //添加医生
    addDoctor() {
      if (!this.search_phone) {
        this.$message.error('请输入医生手机号');
        return false;
      }
      if (this.noinfo) {
        this.$message.error('该账号未注册，请核实');
        return false;
      }
      let doctor_id = this.detail.doctor_id;
      let department_id = this.$route.query.department_id;
      clinic.addDoctorMaintenance({ department_id, doctor_id }).then((res) => {
        if (res.code == 0) {
          this.$message.success('添加成功');
          this.dialogadd = false;
          this.getList();
        }
      });
    }
  },
  created() {
    this.getList();
  }
};
</script>
<style lang="scss" scoped>
.container {
  box-sizing: border-box;
  background-color: #ffffff;
  min-height: calc(100vh - 140px);
}

.box {
  width: 100%;
  box-sizing: border-box;
  padding: 20px;
  .searchbox {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 20px;
  }
}
.diabox {
  padding: 20px 30px 0;
  .diaitem {
    width: 380px;
    display: flex;
    justify-content: space-between;
    margin-bottom: 16px;
    .title {
      width: 70px;
      display: inline-block;
      text-align: right;
    }
    .doctor {
      width: 220px;
      display: flex;
      justify-content: space-between;
    }
  }
}
</style>
